import React, { HTMLProps } from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'src/store';
import { Text } from '../common';
import { IoIosCheckmarkCircle, IoIosClock, IoIosCloseCircle } from 'react-icons/io';

import cn from 'classnames';
import './styles.scss';

const VARIANT_TITLE = {
  active: 'Active',
  completed: 'Completed',
  pending: 'Pending',
  rejected: 'Rejected',
};
const renderIcon = (variant: any) => {
  switch (variant) {
    case 'pending':
      return <IoIosClock size={20} className={`${variant}-header-cardTagIconResults mr-2`} />;
    case 'rejected':
      return <IoIosCloseCircle size={20} className={`${variant}-header-cardTagIconResults mr-2`} />;
    default:
      return <IoIosCheckmarkCircle size={20} className={`${variant}-header-cardTagIconResults mr-2`} />;
  }
};
const DepositionBadge: React.FC<Props> = ({ variant, className, ...props }) => {
  return (
    <span {...props} className={cn(`deposition-badge deposition-badge--${variant}`, className)}>
      {renderIcon(variant)}
      <Text className="deposition-badge__text">{VARIANT_TITLE[variant]}</Text>
    </span>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  HTMLProps<HTMLSpanElement> & {
    variant: 'active' | 'completed' | 'pending' | 'rejected';
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DepositionBadge);
